import React, { createContext } from 'react';
import FHIR from 'fhirclient';
import { SettingsContext } from '../SettingsContext';

export const FhirClientContext = createContext({
    'client': null
});

export class FhirClientProvider extends React.Component {
    static contextType = SettingsContext;

    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            getAuthorizationHeader: this.getAuthorizationHeader
        };
    }

    componentDidMount() {
        if (FHIR) {
            FHIR.oauth2.ready()
                .then((client) => {
                    this.setState({
                        isLoaded: true,
                        client: client
                    });
                })
                .catch(() => { console.log('Error retrieving FHIR data.'); });
        }
    }

    getAuthorizationHeader = () => {
        if (this.state.isLoaded && this.state.client.getAuthorizationHeader) {
            return this.state.client.getAuthorizationHeader();
        } else {
            return '';
        }
    }

    render() {
        const renderChildren = this.state.isLoaded || this.context.features.enableAnonymousAccess;

        return (
            <FhirClientContext.Provider value={this.state}>
                {
                    renderChildren ?
                        this.props.children
                        : null
                }
            </FhirClientContext.Provider>
        );
    }
}

export const FhirClientConsumer = FhirClientContext.Consumer;
